import Gestion from "@/components/seguridad/api/Gestion.js";
import Permisos from "@/components/seguridad/Permisos.js";
import BrowserScan from "@/components/BrowserScan";
let inDevLogin = false;

export default {
  addRoutes(router) {
    router.addRoute({
      path: "/aplicaciones",
      name: "Aplicaciones",
      meta: { auth: true },
      component: () => import("@/components/seguridad/Aplicaciones.vue")
    });
    router.addRoute({
      path: "/cambiar-contrasena",
      name: "CambiarContrasena",
      meta: { auth: true },
      component: () => import("@/components/seguridad/CambiarContrasena.vue")
    });
    router.addRoute({
      path: "/401",
      name: "NoTienePermiso",
      meta: { auth: true },
      component: () => import("@/components/seguridad/NoTienePermiso.vue")
    });

    let loginInRoutes = false;
    router.options.routes.forEach(route => {
      if ("Login" === route.name) {
        loginInRoutes = true;
      }
    });
  
    if (!loginInRoutes) {
      router.addRoute({
        path: "/login",
        name: "Login",
        beforeEnter: () => {
          if (process.env.NODE_ENV == "production") 
            console.log("Hola 1"); // eslint-disable-line
            window.location.href = `${window.location.origin}${process.env.VUE_APP_EXTERNAL_LOGIN}`; 
        }
      });
    }
  },
  guard(store, to, from, next) {
    if (to && from && to.name === from.name) {
      return;
    } 
    let user = store.state.seguridad.usuario;
    console.log(process.env.NODE_ENV); // eslint-disable-line

    let urlPostLogin = to.query.redirectTo || from.query.redirectTo;
    if (urlPostLogin) {
      localStorage.setItem("URL_POST_LOGIN", urlPostLogin);
    } else {
      urlPostLogin = localStorage.getItem("URL_POST_LOGIN");
    }

    if (!user && !inDevLogin && process.env.NODE_ENV === "development") {
      inDevLogin = true;
      console.log("Hola 2"); // eslint-disable-line

      let username = prompt("Usuario", "");
      let password = prompt("Contraseña", "");

      if (username && password) {
        Gestion.autenticar(
          username,
          password,
          inDevLogin ? "dev" : BrowserScan.isMobile() ? "mobile" : "web"
        )
          .then(res => {
            if (res) {
              let jwt = res.headers.authorization;
              store.commit("seguridad/setToken", jwt);
              alert(`Sesión iniciada correctamente`);
              inDevLogin = false;
              location.reload();
            }
          })
          .catch(err => {
            console.error(err); // eslint-disable-line
            if (!err.response) {
              alert(`No se puede establecer conexión con el servidor`);
            } else {
              alert(err.response);
            }
            inDevLogin = false;
          });
      } else {
        alert(
          "DEVMODE: Se actualizará la página para que coloques tu usuario y contraseña"
        );
      }
    }

    if (!inDevLogin) {
      console.log("Hola 3"); // eslint-disable-line

      if (to.matched.some(record => record.meta.auth)) {
        Gestion.validarToken().catch(err => {
          let response = err.response;
          if (response && response.status == 401) {
            Gestion.cerrarSesion();
          }
        });
        let perms = to.meta.perms || [];
        let permSuccess = perms.length > 0 ? false : true;
        if (perms.length > 0) {
          let success = true;
          let booleanOperation = to.meta.permOp || "and";
          perms.forEach(p => {
            if (booleanOperation === "and") {
              success = success && Permisos.puede(p);
            } else {
              success = success || Permisos.puede(p);
            }
          });
          permSuccess = success;
        }

        if (user) {
          if (permSuccess) {
            next();
          } else {
            next({ name: "NoTienePermiso" });
          }
        } else {
          next({ name: "Login" });
        }
      } else if (
        user &&
        to.name == "Login" &&
        (from.path == "/" || from.meta.auth)
      ) {
        next({ name: "Aplicaciones" });
      } else {
        next();
      }
    }
  }
};
